module.exports = __webpack_public_path__ + "static/media/ls03.7a1b2ad1.jpg";